import { render, staticRenderFns } from "./FlowObjectTransitionForm.vue?vue&type=template&id=d817547c&scoped=true"
import script from "./FlowObjectTransitionForm.vue?vue&type=script&lang=js"
export * from "./FlowObjectTransitionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d817547c",
  null
  
)

export default component.exports